const SEGMENT_TYPES = {
  SEGMENT_CHOICE: 'SegmentChoice',
  PAID_SEGMENT_CHOICE: 'PaidSegmentChoice',
  TICKETED_SEGMENT_CHOICE: 'TicketedSegmentChoice',
};

export default SEGMENT_TYPES;
